
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import Api from "services/api"
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { SortButtons } from "components/common/SortButtons";
// import { fetchTranslators } from "slices/inviteTranslatorSlice";
import FullPageLoader from "components/common/FullPageLoader";
import { inviteTranslatorsSelector } from "slices/inviteTranslatorSlice";
import { fetchTranslationsTranslators } from "slices/inviteTranslatorSlice";
import { addInviteTranslators } from "slices/inviteTranslatorSlice";
// import AppointedTranslatorsList from "./AppointedTranslatorsList";
import Swal from "sweetalert2";
import { fetchTranslationView } from "slices/inviteTranslatorSlice";
import { translationsSelector } from "slices/translationSlice";
import { fetchTranslators} from "slices/inviteTranslatorSlice";
import { fetchInvitedTranslators } from "slices/inviteTranslatorSlice";
import AppointedTranslatorsList from "./AppointedTranslatorsList";


const apiService = new Api();
function InviteTranslatorList({ itemId, translationData }) {
    const sasa = useSelector(inviteTranslatorsSelector);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [showInvitedList, setInvitedList] = useState(false);
    const fetchingList = async () => {
        setLoading(true)
        // await dispatch(fetchTranslationsTranslators(itemId))
        await dispatch(fetchTranslators(itemId))
        setLoading(false)
    }
    React.useEffect(() => {
        fetchingList()
    }, [])


    const handleInvitedList = React.useCallback(() => {
        setInvitedList(true);
        // scroll to this div interperters-with-appt

    }, [showInvitedList])

    // useEffect(() => {
    //     if (showInvitedList) {
    //         const element = document.getElementById("interperters-with-appt");
    //         element.scrollIntoView({ behavior: "smooth" });
    //     }
    // }, [showInvitedList])


    return (
        <>
            <InviteTranslators height={'height-auto'} itemId={itemId} translationData={translationData} mainLoader={loading} handleInvitedList={handleInvitedList} invitedList={showInvitedList} 
           />
            <AppointedTranslatorsList height={'height-auto'}  itemId={itemId} handleInvitedList={handleInvitedList} invitedList={showInvitedList} fetchAppointment={fetchingList} />


            {/* <div id="interperters-with-appt">   </div> */}

            {loading && <FullPageLoader />}
        </>

    )
}

const InviteTranslatorItem = ({
    item, index, selectedItems, handleChange, handleAddPopUp
}) => {
    const dispatch = useDispatch();

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{index + 1}</span>
                    <label className="custom-checkbox checkbox">
                        <input type="checkbox" name="select-all" data-value={item?.id} checked={selectedItems?.includes(item?.id?.toString())} onChange={handleChange} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </td>
            <td>
                {item?.first_name + " " + item?.last_name}
            </td>
            <td>
                {item?.user?.email}
            </td>
            <td>
                {item?.phone}
            </td>
            <td>
                {item?.languages?.map(l => l?.language?.name + ", ")}
            </td>

        </tr>
    )
}

const InviteTranslators = ({ mainLoader, handleInvitedList, invitedList, itemId, translationData, height,  }) => {
    const dispatch = useDispatch()
    const { inviteTranslators, last_page: totalPages, loader, allTranslators } = useSelector(inviteTranslatorsSelector);

    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}

    });
    const navigate = useNavigate()
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });

    const handlePageChange = React.useCallback((page) => {
        setCurrentPage(page);
        // dispatch(fetchTranslators(page));
    }, [])
    const handleAddInviteTranslatorPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }

    const handleSubmitInviteTranslators = React.useCallback(() => {
        const submitCallback = (status, message) => {
            if (status) {
                toast.success(message, {
                    className: "successToast",
                })
                setSelectedItems([]);
                setSelectAll(false)
                dispatch(fetchTranslators(itemId))
                dispatch(fetchInvitedTranslators(itemId))
                // dispatch(fetchTranslationView(itemId))

                //   dispatch(fetchOtherInviteTranslators())
                hideConfirmDialog()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
            }
        };
        new Swal({
            title: "Are you sure?",
            text: "You want to invite these translators?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(addInviteTranslators({ translator_ids: selectedItems, }, itemId, submitCallback))
            }
        })
    }, [selectedItems, itemId])

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    const handleToggleSelectAll = React.useCallback(() => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(allTranslators.map((inviteTranslator) => inviteTranslator.id.toString()))
    }, [selectedItems, selectAll, allTranslators])
    



    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Phone</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Languages</p>
                    </div>
                </th>

            </tr>
        )
    }, [selectedItems, allTranslators])


    const renderTableContent = React.useCallback(() => {

        return (
            allTranslators?.map((item, index) => {
                return <InviteTranslatorItem item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInviteTranslatorPopUp} />
            })
        )
    }, [allTranslators, selectedItems]);

    const handleClose = React.useCallback(() => {
        refAddutton.current.click();
        setAddForm({ show: false })
    }, [])


    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };

    
    const renderFooter = React.useCallback(() => {
        return (
            <div className="row-primary">

                <button
                    onClick={handleSubmitInviteTranslators}
                    disabled={selectedItems?.length == 0}
                    className="main_button"
                    style={{

                        // float: "right",
                        marginRight: 20
                    }}
                >
                    Invite Translators
                </button>

                {/* <button
                    onClick={handleInvitedList}
                    className="main_button"
                    style={{

                        // float: "right",
                        marginRight: 20
                    }}
                >
                    Translators with Appointment
                </button> */}
            </div>
        )
    }, [selectedItems, invitedList, handleInvitedList])



    return (
        <>
            <ListLayout
                heading={`Invite Translator`}
                time={false}
                height={height}
                title="Translators"
                addButtonDisabled={true}
                buttonTitle="Add InviteTranslator"
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                totalPages={totalPages}
                fetchList={fetchTranslators}
                selectedItems={selectedItems}
                // handleRemoveItems={handleRemoveItems}
                // renderAddForm={<AddInviteTranslator item={addForm.item} show={addForm.show} onClose={handleClose} />}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddInviteTranslatorPopUp}
                renderFooter={renderFooter}
                hideRemoveButton={true}
                // loader={mainLoader}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                haveBackBtn={true}
                onBackButtonClick={
                    () => navigate(`/translation/view/${itemId}`)
                }
            >
            </ListLayout>
        </>
    )

}

export default InviteTranslatorList;
